import { createAction, props } from '@ngrx/store';

import { DawbaRoutes } from '../../route-constants';
import { IDawbaSpecificState } from './dawba-specific.reducer';

export const appLoad = createAction('[DAWBA] App InitialLoad');

export const appLoadSuccess = createAction('[DAWBA] App Load Success');

export const appLoadFailure = createAction('[DAWBA] App Load Failure');

export const initPrimaryFhirLoad = createAction(
  '[DAWBA] Init Primary FHIR Load'
);

export const primaryFhirLoadSuccess = createAction(
  '[DAWBA] Primary FHIR Load Success'
);

export const primaryFhirLoadFailure = createAction(
  '[DAWBA] Primary FHIR Load Failure'
);

export const update = createAction(
  '[DAWBA] Update',
  props<{ update: Partial<IDawbaSpecificState> }>()
);

export const setCurCarePlan = createAction(
  '[DAWBA] Set current care plan',
  props<{ curCarePlanId: string }>()
);

export const setCurCarePlanSuccess = createAction(
  '[DAWBA] Set current care plan success',
  props<{ route: DawbaRoutes }>()
);

export const setCurCarePlanFailure = createAction(
  '[DAWBA] Set current care plan failure',
  props<{ route: DawbaRoutes }>()
);

export const resetState = createAction('[DAWBA] resetState');

export const dawbaSpecificActions = {
  initPrimaryFhirLoad,
  primaryFhirLoadSuccess,
  primaryFhirLoadFailure,
  resetState,
  update,
  setCurCarePlan,
  setCurCarePlanSuccess,
  setCurCarePlanFailure,
  appLoad,
  appLoadSuccess,
  appLoadFailure,
};
